import { useState } from "react";
import { PDF_CANVAS_MAX_WIDTH } from "../pdfCanvasConstants";

export function usePdfDisplayerChrome(readOnly: boolean, eskiYontem: boolean) {
    const [pdfWidth, setPdfWidth] = useState(PDF_CANVAS_MAX_WIDTH);
    const [isPreviewVisible, setIsPreviewVisible] = useState(true);
    const [isHataNotPanelVisible, setIsHataNotPanelVisible] = useState(readOnly && !eskiYontem);
    const [isLegendVisible, setIsLegendVisible] = useState(!readOnly && !eskiYontem);

    const resetChrome = () => {
        setPdfWidth(PDF_CANVAS_MAX_WIDTH);
        setIsPreviewVisible(true);
        setIsHataNotPanelVisible(readOnly && !eskiYontem);
        setIsLegendVisible(!readOnly && !eskiYontem);
    };

    return {
        pdfWidth,
        setPdfWidth,
        isPreviewVisible,
        setIsPreviewVisible,
        isHataNotPanelVisible,
        setIsHataNotPanelVisible,
        isLegendVisible,
        setIsLegendVisible,
        resetChrome,
    };
}
